<template>
    <div>
        <div class="md:pt-6">
            <div class="mx-auto px-4 sm:px-6 md:px-8">
                <h1 class="text-2xl font-semibold text-gray-900">
                    <SmartBreadcrumbs
                        type="a"
                        :pages="[
                            {
                                name: $t('messages.usage_information'),
                                href: null,
                            },
                        ]"
                    />
                </h1>
            </div>
        </div>

        <!--        Widgets section-->
        <UsageStatsWidgets :widgets="widgets" />
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import UsageStatsWidgets from '@/components/UsageStatsWidgets.vue';

export default {
    components: {
        UsageStatsWidgets,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'teacher', 'widgets'],
    data() {
        return {};
    },
    methods: {},
};
</script>
